export const GET_SERVICE_CATEGORIES = "GET_SERVICE_CATEGORIES";
export const CREATE_SERVICE_CATEGORY = "CREATE_SERVICE_CATEGORY";
export const UPDATE_SERVICE_CATEGORY = "UPDATE_SERVICE_CATEGORY";
export const DELETE_SERVICE_CATEGORY = "DELETE_SERVICE_CATEGORY";
